import React from "react";
import EntranceExaminationPage from "./EntranceExaminationPage";

const EntranceEnglishLanguage = () => {
    return (
        <EntranceExaminationPage
            subject="english"
        />
    );
};

export default EntranceEnglishLanguage;